import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';

import {
    VBTogglePlugin,
    BCard,
    BButton,
    BCollapse,
} from 'bootstrap-vue';

import {
    quotesMenuMixin
} from './vue/mixins/quotes';
import QuoteSearch from './vue/components/quote-search/QuoteSearch.vue';

const mixins = [];
mixins.push(quotesMenuMixin);
initMain(mixins, {
    BCard,
    BButton,
    BCollapse,
    QuoteSearch,
    QuoteGraph: () => import('./vue/components/quote-graph/QuoteGraph.vue'),
    QuoteBarGraph: () => import('./vue/components/quote-bar-graph/QuoteBarGraph.vue'),
    DolarSpotGraph: () => import('./vue/components/dolar-spot-graph/DolarSpotGraph.vue'),
    QuoteMultipleGraph: () => import('./vue/components/quote-multiple-graph/QuoteMultipleGraph.vue'),
    QuoteMultiselectGraph: () => import('./vue/components/quote-multiselect-graph/QuoteMultiselectGraph.vue'),
    RecentQuotes: () => import('./vue/components/recent-quotes/RecentQuotes.vue'),
    Trends: () => import('./vue/components/trends/Trends.vue'),
}, [VBTogglePlugin]);
header();